module.exports = __webpack_public_path__ + "static/media/whatWeOfferConsult.04613318.svg";